// Profile of Nikolai Genov, Italian. Source of the profile page.
module.exports = {
  headline: 'AI & Data Science Lead • Sanità, scienze della vita, finanza',
  summary: 'Dottore di ricerca in bioinformatica e responsabile tecnico operativo, che unisce lo sviluppo software assistito dall’IA all’analisi dei dati in contesti regolamentati della sanità, delle scienze della vita e della finanza. Le sue competenze comprendono sistemi LLM/RAG, integrazione MCP, dati clinici, previsioni bancarie a cinque anni e reportistica Excel automatizzata. Coniuga lo sviluppo in R/Python con il coordinamento dei team, la garanzia della qualità e workshop a livello dirigenziale; certificazione AI Act e formazione GCP.',
  imageAlt: 'Ritratto di Nikolai Genov',
  personal: {
    position: 'Cofondatore e amministratore delegato di pAIoneer Labs GmbH, amministratore delegato di Leap Dynamics GmbH',
    location: 'Berlino, Germania',
    languages: 'Tedesco e inglese (fluenti), bulgaro (fluente)',
    programmingLanguages: 'R, Python, SQL/SQLite, SAS, MATLAB',
    certifications: 'Certificazione AI Act, formazione GCP (2025)',
    publications: 'Lavori scientifici sottoposti a revisione paritaria su Scientific Reports, PLOS Biology, IJMS, Frontiers in Physiology e PLOS ONE'
  },
  education: [
    {
      period: '2021',
      field: 'Dottorato: bioinformatica / biologia teorica',
      institution: '',
      degree: 'Titolo: dottorato di ricerca (Dr. rer. nat.)'
    },
    {
      period: '2015',
      field: 'Studi: bioinformatica',
      institution: 'Freie Universität Berlin',
      degree: 'Titolo: M.Sc. in bioinformatica'
    },
    {
      period: '2012',
      field: 'Studi: bioinformatica',
      institution: 'Freie Universität Berlin',
      degree: 'Titolo: B.Sc. in bioinformatica'
    }
  ],
  skills: [
    {
      title: 'Competenze chiave',
      description: 'Sviluppo assistito dall’IA, R/Python, LLM/RAG e MCP, dati clinici e bioinformatica, previsioni e stress test, reportistica Excel, Shiny, leadership tecnica'
    },
    {
      title: 'Programmazione e analisi dei dati',
      description: 'R, Python, SQL/SQLite, SAS, MATLAB; ggplot2, scikit-learn, Keras/TensorFlow'
    },
    {
      title: 'Applicazioni e reportistica',
      description: 'R Shiny, Streamlit, Tableau, Leaflet, R Markdown, knitr, LaTeX; reportistica automatizzata in Excel/Word/PDF'
    },
    {
      title: 'IA e integrazione',
      description: 'OpenCode, ChatGPT, Model Context Protocol (MCP); Ollama, vLLM, LM Studio, Open WebUI, RAG, n8n, Flowise; sviluppo assistito dall’IA con revisione umana'
    },
    {
      title: 'Ingegneria',
      description: 'Azure DevOps, GitLab CI/CD, Docker, Camunda, Linux, Microsoft Azure, Google Cloud Platform'
    },
    {
      title: 'Bioinformatica',
      description: 'RNA-seq, microarray, splicing alternativo/isoforme, arricchimento di set genici, analisi di pathway e reti, assemblaggio del genoma, analisi di sopravvivenza; Bioconductor, Cytoscape, GEO, ArrayExpress, Ensembl BioMart, UniProt/Swiss-Prot, GO, Reactome, KEGG, BioGRID, STRING, ChEMBL'
    },
    {
      title: 'Dati clinici',
      description: 'EDC, CRF, edit check, DMP, piani di validazione dei dati, UAT, riconciliazione SAE; CDISC SDTM/ADaM, pipeline RAW/SDTM/ADaM, QC'
    }
  ],
  positions: [
    {
      period: '2022 - aprile 2024',
      title: 'Automazione della reportistica, T-Systems / Banca centrale europea (BCE)',
      description: [
        'Sviluppo di una libreria R per report statistici su serie temporali finanziarie; migrazione della logica FAME verso R/Python con Reticulate e output Word/PDF automatizzati.',
        'Sviluppo di pipeline per la generazione automatizzata di report Excel; integrazione delle analisi con Camunda e supporto a GitLab CI/CD, unit test, linting, SonarQube e documentazione.',
        'Sostituzione del responsabile del team e contributo alla pianificazione degli sprint, al coordinamento tecnico, alla garanzia della qualità e al lavoro a contatto con gli stakeholder.'
      ]
    },
    {
      period: 'Giugno 2025 - dicembre 2025',
      title: 'Data Science & Risk Analytics Consultant, settore bancario',
      description: [
        'Sviluppo di modelli di previsione con orizzonti di pianificazione fino a cinque anni e implementazione di stress test.',
        'Riscrittura e refactoring di codice R preesistente, ottimizzazione di quattro processi aziendali e sviluppo assistito dall’IA con revisione umana per implementazione e documentazione.',
        'Realizzazione di flussi di analisi in R/Shiny e di pipeline per la generazione automatizzata di report Excel; traduzione dei requisiti di business in implementazioni analitiche.'
      ]
    },
    {
      period: 'Giugno 2025 - giugno 2026',
      title: 'Clinical Data Manager, farmaceutica / studi clinici',
      description: [
        'Gestione di setup EDC, progettazione delle CRF, edit check, ruoli utente, specifiche di trasferimento dei dati e UAT; coordinamento con CRO, laboratori e team di studio.',
        'Redazione e revisione di DMP, piani di validazione, piani di riconciliazione SAE e documentazione UAT; sviluppo di flussi di validazione basati su R e di applicazioni Shiny in un contesto rilevante per le GCP.'
      ]
    },
    {
      period: 'Luglio 2026',
      title: 'Pipeline di dati clinici, Dr. Falk Pharma',
      description: [
        'Realizzazione di una pipeline RAW/SDTM/ADaM in R con OpenCode e sviluppo assistito dall’IA, con validazione, QC, tracciabilità e pipeline automatizzate di report Excel.'
      ]
    },
    {
      period: '2026',
      title: 'Reportistica di audit trail assistita dall’IA, Miltenyi Biotec',
      description: [
        'Implementazione di report di audit trail e di pipeline automatizzate di report Excel con OpenCode e sviluppo assistito dall’IA, incluse logica dei report, debugging, documentazione e revisione umana.'
      ]
    },
    {
      period: 'Dal 2019',
      title: 'CEO e cofondatore / AI & Data Lead, Leap Dynamics GmbH',
      description: [
        'Guida della consulenza e della realizzazione tecnica in sanità, scienze della vita, finanza e IA, unendo lo sviluppo in prima persona al coordinamento dei team e alla comunicazione con gli stakeholder.',
        'Progettazione di un’infrastruttura LLM/RAG e dell’integrazione di tool basata su MCP. Introduzione di flussi di lavoro R/Python assistiti da OpenCode per generazione di codice, refactoring, test e documentazione con revisione umana.'
      ]
    },
    {
      period: 'Dal 2022',
      title: 'Registro tumori e biobanca, Medical University Pleven',
      description: [
        'Analisi dei dati del registro tumori nazionale e realizzazione di dashboard Shiny per stakeholder clinici e della ricerca; supporto all’integrazione, alla documentazione e ai flussi di lavoro della biobanca per cinque tipi di tumore.'
      ]
    },
    {
      period: 'Dal 2025',
      title: 'Lead Developer, AI Map Europe (ai-map.eu)',
      description: [
        'Realizzazione di un’applicazione R Shiny pronta per la produzione; migrazione dei dati da CSV a SQLite e aggiunta di autenticazione per gli amministratori, gestione delle istituzioni, statistiche sui visitatori, inserzioni a pagamento e moduli di richiesta con notifiche SMTP.',
        'Miglioramento di UI/UX responsive, SEO, dati strutturati e supporto sitemap/robots; aggiunta di validazione degli input, escaping degli output, limitazione dei tentativi di login e pubblicazione dei soli record verificati. Verifica di oltre 400 istituzioni sulla base di ELLIS, CAIRNE, AI NATION, NET4AI, INSAIT e AI-on-Demand, con documentazione della provenienza e documentazione di deployment e sicurezza.'
      ]
    },
    {
      period: 'Dal 2024',
      title: 'Analisi di notizie finanziarie basata su LLM, Leap Dynamics (progetto interno)',
      description: [
        'Realizzazione di flussi ricorrenti di analisi del sentiment con LLM, dati da API, report PDF automatizzati, un’interfaccia Streamlit, orchestrazione con n8n e test dei flussi di lavoro con il supporto di Flowise.'
      ]
    },
    {
      period: '2025',
      title: 'Workshop a livello dirigenziale, BVMW',
      description: [
        'Conduzione di workshop per partecipanti a livello di direzione aziendale nella rete BVMW.'
      ]
    },
    {
      period: '2015 - 2019',
      title: 'Collaboratore scientifico, Humboldt-Universität / Charité, Berlino',
      description: []
    },
    {
      period: '2015 - 2017',
      title: 'CTO e cofondatore, Promethano GmbH',
      description: [
        'Software per le scienze della vita e applicazioni per serie temporali.'
      ]
    }
  ]
};
